<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('scope.wecom.group.perform_ready') }}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('scope.wecom_ext_groups_list')" :count="params.data.length" :action="$t('scope.wecom.group.perform_ready')" />
      <dialog-table :data="params.data" :columns="columns" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'WecomExtGroupReadyDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  computed: {
    columns () {
      const showFields = ['name', 'status', 'created_at']
      return this.params.columns.filter((item) => { return showFields.includes(item.field) })
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.params.onManager('performAction', {
          id: this.params.data[0].id,
          managerArgs: {
            action: 'ready',
          },
        })
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('common.success'))
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
